import React from "react"
import DiscountModal from "./discount-modal"
import USD from "../../../components/usd"

class Discount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDiscountModal: false
    };
    this.openDiscountModal = this.openDiscountModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openDiscountModal(e) {
    this.setState({showDiscountModal: true})
  }

  closeModal() {
    this.setState({showDiscountModal: false})
  }

  render() {
    return (
      <div className="shop-cart__option shop-cart__discount" onClick={this.openDiscountModal} >
          <div className="shop-cart__discount-title">
            <span className='shop-cart-row__discount'>Discount<i className="shop-cart__pencil" aria-hidden="true"></i></span>
          </div>
          <div>
            <div className="shop-cart__amount"><USD val={parseFloat(this.props.amountDiscount)}/></div>
            <div className="shop-cart__amount">{this.props.percentageDiscount}%</div>
          </div>
          {this.state.showDiscountModal &&
            <DiscountModal styles={{top: '-70px', right: 'calc(100% + 35px)'}}
                           onRequestClose={this.closeModal}
                           onSetDiscount={this.props.onSetDiscount}
                           onCorrectDiscount={this.props.onCorrectDiscount}
            />
          }
      </div>
    )
  }
}

export default Discount
